import React, { Component } from 'react'
// import { Route, Switch } from 'react-router-dom'
import { withTheme } from 'material-ui/styles'
// import _ from 'lodash'

import core from '../../core'
import common from '../../common'

import { PATH, LABEL, NAME, FORM, subForms } from '../constants'

import { getEnrichedRegister } from '../helpers'

import * as configs from '../configs'

const {
  subFormsDispatcher,
  getConfig,
  commonConfigValues,
  getDataFunctions
} = configs

const {
  constants: { valueTable },
  helpers: { compactData, updateHistory, handlePersonAdd },
  components: { InnerRouter }
} = common

const {
  // components: { Auth, NoMatch },
  constants: { DATE_FORMAT }
} = core

class Container extends Component {
  render() {
    const propsToPass = {
      subFormsDispatcher,
      getData: getEnrichedRegister,
      helpers: {
        compactData,
        updateHistory,
        handlePersonAdd
      },
      constantProps: { PATH, LABEL, NAME, DATE_FORMAT, FORM }
    }

    return (
      <InnerRouter
        {...this.props}
        innerRouterInput={{
          commonConfigValues,
          valueTable,
          subForms,
          propsToPass,
          getConfig,
          getDataFunctions,
          listScreenData: [
            { id: 1 },
            { id: 2 },
            { id: 3 },
            { id: 4 },
            { id: 5 },
            { id: 6 }
          ]
        }}
      />
    )
  }
}

export default withTheme()(Container)



// WEBPACK FOOTER //
// ./src/centre/components/Container.js